type GetAccountNameArgs = {
  displayName?: string | null;
  institutionName?: string;
};

export const getBankAccountName = ({ displayName, institutionName }: GetAccountNameArgs) => {
  // Return first non-empty value in priority order, with fallback
  // Fallback is a hardcoded value to ensure we always return a value (should be an edge case)
  // Open to suggestions on a better fallback value
  return displayName || institutionName || 'Bank account';
};
